import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

class InfluencerLabels extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab : 'feed',
      label_hints : [],
    };
  }
  // -------------------------------------------------------
  
  /*
   * ラベル選択
   */
  select(label, e) {
    this.label.value = label;
    this.submit.bind(this)(e);
  }
  // -------------------------------------------------------
  
  /*
   * ラベル追加
   */
  submit(e) {
    e.preventDefault();
    document.activeElement.blur();
    
    let label = this.label.value;
    if( label == '' ) return;
    
    this.label.value = '';
    this.setState({ label_hints: [] });
    this.setLabel.bind(this)({ mode: 'input', name: label });
  }
  // -------------------------------------------------------
  
  /*
   * ラベル削除
   */
  delete(label_id, label_name) {
    let chk = confirm('「 '+ label_name +' 」 を削除してもよろしいですか？');
    if( chk == false ) return;
    
    this.setLabel.bind(this)({ mode: 'delete', label_id: label_id });
  }
  // -------------------------------------------------------
  
  /*
   * データ取得
   */
  setLabel(option) {
    Utils.request.bind(this)('/api/influencer/set_labels', { insta_user_id: this.props.data.insta_user_id, option: option },
      function(res){
        this.props.refresh_ev.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * ラベルヒント設定
   */
  setLabelHints() {
    let hints = [];
    this.props.data.label_mst.map((d) => {
      if( this.label.value == '' ) return;
      
      // 未選択のラベルを表示
      let flg = true;
      this.props.data.labels.map((l) => { if( l.label_id == d.id ) flg = false; });
      
      if( d.name.indexOf(this.label.value) !== -1 && flg == true ) hints.push(d);
    });
    
    this.setState({ label_hints: hints });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    if( this.props.ng_html != null ) return this.props.ng_html;
    
    return (
      <div className="influencer-labels">
        
        <div className="label-forms">
          <form className="forms">
            <input className="text" type="text" ref={(input) => { this.label = input }} onChange={this.setLabelHints.bind(this)} placeholder="ラベル名" />
            <div className="submit button" onClick={this.submit.bind(this)}>送信</div>
            
            <button className="hide" onClick={this.submit.bind(this)}></button>
          </form>
          
          { (this.state.label_hints.length > 0 ) &&
            <ul className="label-hints">
              { this.state.label_hints.map((d, key) => {
                return <li key={key} onClick={this.select.bind(this, d.name)}>{d.name} <p className="right">{d.cnt}人</p></li>
              })}
            </ul>
          }
        </div>
        
        <ul className="labels">
          { data.labels.map((d, key) => {
            return <li key={key}>{d.name}<p className="close" onClick={this.delete.bind(this, d.id, d.name)}>×</p></li>
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerLabels;